import type { StateCreator } from 'zustand'

import { type VoucherTravelState, INITIAL_STATE } from './type'

const createVoucherTravelSlice: StateCreator<VoucherTravelState, [], [], VoucherTravelState> = (
  set,
) => ({
  voucherTravel: INITIAL_STATE,
  setVoucherTravel: (travelers) =>
    set((state) => ({
      voucherTravel: { ...state.voucherTravel, travelers },
    })),
  setVoucherPlanType: (planType: string): void => {
    set((state) => ({
      voucherTravel: { ...state.voucherTravel, planType },
    }))
  },
  resetVoucherTravel: () => set(() => ({ voucherTravel: INITIAL_STATE })),
})

export default createVoucherTravelSlice
